// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { useTranslation } from 'react-i18next'
import { Logo } from '@/components/Logo'

export function AppLoader() {
  const { t } = useTranslation()
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-br from-[#012031] via-[#033C85] to-[#006EF9]"
    >
      {/* Decorative orbs */}
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#02C7C3]/15 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-white/5 blur-3xl pointer-events-none" />

      <div className="relative flex items-center justify-center">
        {/* Spinning gradient ring */}
        <svg
          className="absolute animate-spin-ring"
          width="88"
          height="88"
          viewBox="0 0 88 88"
          fill="none"
          aria-hidden
        >
          <circle cx="44" cy="44" r="40" stroke="url(#ring-grad)" strokeWidth="3" strokeLinecap="round"
            strokeDasharray="160 92" />
          <defs>
            <linearGradient id="ring-grad" x1="0" y1="0" x2="88" y2="88" gradientUnits="userSpaceOnUse">
              <stop stopColor="#02C7C3" />
              <stop offset="1" stopColor="#006EF9" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>

        {/* Logo mark centred inside ring */}
        <div
          className="w-14 h-14 rounded-full bg-white/15 border border-white/25 flex items-center justify-center animate-float"
          style={{ filter: 'brightness(0) invert(1)' }}
        >
          <Logo variant="mark" className="w-7 h-7" aria-hidden />
        </div>
      </div>

      {/* Wordmark */}
      <div className="mt-8 animate-fade-up" style={{ animationDelay: '200ms', filter: 'brightness(0) invert(1)' }}>
        <Logo variant="wordmark" className="h-6 w-auto opacity-80" aria-hidden />
      </div>

      {/* Tagline */}
      <p className="mt-3 text-white/45 text-xs tracking-widest uppercase animate-fade-up"
        style={{ animationDelay: '350ms' }}>
        {t('common.preparing')}
      </p>
    </div>
  )
}
